<template>
    <div class="header-container flex flex-col lg:flex-row gap-2.5 w-full rounded-[20px] bg-white overflow-y-auto max-h-[85vh] cursor-default">
        <div class="flex lg:hidden items-center px-5 gap-3" @click="$emit('close-item')">
            <UButton
                color="primary"
                variant="outline"
                size="sm"
                label="Back"
                class="inline-flex items-center justify-start font-manrope text-base leading-5 font-bold tracking-[-0.3px] text-primary-600"
            >
                <template #leading>
                    <UIcon name="i-lucide-arrow-left" class="w-[18px] h-[18px]" />
                </template>
            </UButton>
            <span class="font-manrope text-base leading-5 font-medium tracking-[-0.3px] text-[#a4a4a4]">{{ menuName }}</span>
        </div>
        <component
            :is="resolvedComponent"
            :sub-menus="subMenus"
            @handle-collapse="$emit('handle-collapse')"
        />
    </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, computed } from 'vue';
import Style1 from '~/components/layout/header/style-1';
import Style2 from '~/components/layout/header/style-2';
import Style3 from '~/components/layout/header/style-3';

const props = defineProps({
    subMenus: {
        type: Array,
        default: () => ([]),
    },
    menuVersion: {
        type: String,
        default: 'style1',
    },
    menuName: {
        type: String,
        default: '',
    },
});

defineEmits(['close-item', 'handle-collapse']);

const componentsMap = {
    Style1,
    Style2,
    Style3,
};

const resolvedComponent = computed(() => {
    return componentsMap[props.menuVersion] || Style1;
});

const updateTargetWidth = () => {
    if (!import.meta.client) return;

    const sourceDiv = document.getElementById('navbar');
    if (!sourceDiv) return;

    const targetDivs = document.querySelectorAll('#nav-item-style-1');
    if (targetDivs.length > 0) {
        const targetDiv = targetDivs[0];
        const sourceDivWidth = sourceDiv.offsetWidth;
        targetDiv.style.width = sourceDivWidth + 'px';
    }
    if (targetDivs.length > 1) {
        const targetDiv = targetDivs[1];
        const sourceDivWidth = sourceDiv.offsetWidth;
        targetDiv.style.width = sourceDivWidth + 'px';
    }
};

onMounted(() => {
    if (import.meta.client) {
        window.addEventListener('resize', updateTargetWidth);
        updateTargetWidth();
    }
});

onBeforeUnmount(() => {
    if (import.meta.client) {
        window.removeEventListener('resize', updateTargetWidth);
    }
});
</script>

<style lang="scss" scoped>
.header-container {
    @media screen and (min-width: 992px) {
        overflow-y: unset;
    }

    .nav-img {
        width: 80px;
        height: 80px;
        @media screen and (min-width: 992px) {
            width: 120px;
            height: 120px;
        }
    }
}
</style>
